import { IGuestSessionInput } from "types/api/layout";

export const getGuestSessionPayload = (): IGuestSessionInput => {
  const hasWindow = typeof window !== "undefined";
  const hasNavigator = typeof navigator !== "undefined";
  const hasIntl = typeof Intl !== "undefined";

  return {
    metadata: {
      platform: "web",
      screen_width: hasWindow ? window.screen.width : 0,
      screen_height: hasWindow ? window.screen.height : 0,
      viewport_width: hasWindow ? window.innerWidth : 0,
      viewport_height: hasWindow ? window.innerHeight : 0,
      timezone: hasIntl
        ? Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Tehran"
        : "Asia/Tehran",
      language: hasNavigator ? navigator.language || "fa-IR" : "fa-IR",
    },
  };
};
